import axios from "axios";
import { authConfig, endpoint } from "./http";

export async function listTradeOffers({ apiUrl, accessToken }) {
  return (await axios.get(endpoint(apiUrl, "/trade-offers"), authConfig(accessToken))).data;
}
export async function createTradeOffer({ apiUrl, accessToken, targetId, offeredId, message }) {
  return (await axios.post(endpoint(apiUrl, "/trade-offers"), {
    target_listing_id: targetId, offered_listing_id: offeredId, message,
  }, authConfig(accessToken))).data;
}
export async function updateTradeOffer({ apiUrl, accessToken, offerId, status }) {
  return (await axios.patch(endpoint(apiUrl, `/trade-offers/${offerId}`), { status }, authConfig(accessToken))).data;
}
export async function listTradeListings({ apiUrl }) {
  return (await axios.get(endpoint(apiUrl, "/listings"), { params: { trade_only: true } })).data;
}
